import { Component, Input } from '@angular/core';

@Component({
  selector: 'app-error-bar-pill',
  templateUrl: './error-bar-pill.component.html',
  styleUrls: ['./error-bar-pill.component.scss'],
})
export class ErrorBarPillComponent {
  @Input() errors: number = 0;
  @Input() mistakes: number = 0;
  @Input() checks: number = 0;
  @Input() showPercent: boolean = false;
  @Input() showBorder: boolean = false;
  @Input() colorPallete: any;

  redWidth: number = 0;
  amberWidth: number = 0;
  greenWidth: number = 0;
  total: number = 0;

  ngOnChanges(): void {
    this.total = this.errors + this.mistakes + this.checks;
    if (this.total > 0) {
      const rawRedWidth = (this.errors / this.total) * 100;
      const rawAmberWidth = (this.mistakes / this.total) * 100;
      const rawGreenWidth = (this.checks / this.total) * 100;

      const roundedRedWidth = Math.round(rawRedWidth);
      const roundedAmberWidth = Math.round(rawAmberWidth);
      const roundedGreenWidth = Math.round(rawGreenWidth);

      const roundedTotal = roundedRedWidth + roundedAmberWidth + roundedGreenWidth;
      if (roundedTotal !== 100) {
        const diff = 100 - roundedTotal;
        if (diff > 0) {
          this.adjustWidthsUp(diff, roundedRedWidth, roundedAmberWidth, roundedGreenWidth);
        } else {
          this.adjustWidthsDown(diff, roundedRedWidth, roundedAmberWidth, roundedGreenWidth);
        }
      } else {
        this.redWidth = roundedRedWidth;
        this.amberWidth = roundedAmberWidth;
        this.greenWidth = roundedGreenWidth;
      }

      // this.redWidth = rawRedWidth;
      // this.amberWidth = rawAmberWidth;
      // this.greenWidth = rawGreenWidth;
    }
  }

  adjustWidthsUp(diff: number, red: number, amber: number, green: number): void {
    const widths = [
      { key: 'redWidth', value: red },
      { key: 'amberWidth', value: amber },
      { key: 'greenWidth', value: green },
    ];
    widths.sort((a, b) => b.value - a.value);

    for (let i = 0; i < diff; i++) {
      widths[i].value++;
    }

    this.redWidth = widths.find((w) => w.key === 'redWidth')!.value;
    this.amberWidth = widths.find((w) => w.key === 'amberWidth')!.value;
    this.greenWidth = widths.find((w) => w.key === 'greenWidth')!.value;
  }

  adjustWidthsDown(diff: number, red: number, amber: number, green: number): void {
    const widths = [
      { key: 'redWidth', value: red },
      { key: 'amberWidth', value: amber },
      { key: 'greenWidth', value: green },
    ];
    widths.sort((a, b) => a.value - b.value);

    for (let i = 0; i < -diff; i++) {
      widths[i].value--;
    }

    this.redWidth = widths.find((w) => w.key === 'redWidth')!.value;
    this.amberWidth = widths.find((w) => w.key === 'amberWidth')!.value;
    this.greenWidth = widths.find((w) => w.key === 'greenWidth')!.value;
  }
}
